module.exports = __webpack_public_path__ + "8cd7ceede7f24b059c7b2eb7622a5ee9.woff";